import { LoginPayload, LoginResponse, User } from 'types/auth';
import { api } from './instance';

export const login = async (payload: LoginPayload) => {
  const { data } = await api.post<LoginResponse>(`/auth/login-tenant`, payload);
  return data;
};
